import { Contract } from "@/services/backend/vbs/contracts/types/contract";
import {
  updateVbsContractCache,
  useVbsContractResetReferenceNumberMutation,
  useVbsContractPatchMutation,
} from "@/services/backend/vbs/contracts/api/contract-api";
import { ReferenceNumberField } from "@/services/backend/documents/components/reference-number-field";
import { isImmutable } from "@/services/backend/documents/lib/document-state";

/**
 * ContractReferenceNumberField edits the reference number of a contract.
 */
export function ContractReferenceNumberField({
  contract,
  disabled = false,
}: {
  contract: Contract;
  disabled?: boolean;
}) {
  const patchReferenceNumber = useVbsContractPatchMutation();
  const resetReferenceNumber = useVbsContractResetReferenceNumberMutation();

  return (
    <ReferenceNumberField
      data={contract}
      updateCache={updateVbsContractCache}
      patchMutation={patchReferenceNumber}
      resetMutation={resetReferenceNumber}
      disabled={disabled || isImmutable(contract)}
    />
  );
}
